<template>
	<div v-if="src" class="x-image">
		<img v-if="previewSrc" :src="previewSrc" @click="preview" :width="width + 'px'" :height="height + 'px'" />
		<img v-else :src="src" @click="preview" :width="width" :height="height" />
		<a-modal
			:visible="previewVisible"
			:footer="null"
			:zIndex="3000"
			:getContainer="getContainer"
			@cancel="cancel"
		>
			<img class="cover-img" style="width:100%" :src="modalSrc" alt="" />
		</a-modal>
	</div>
</template>

<script>
	export default {
		props: {
			src: {
				type: String,
				required: true
			},
			width: {
				type: Number,
				required: false,
				default: 64
			},
			height: {
				type: Number,
				required: false,
				default: 64
			},
			previewSrc: {
				type: String,
				required: false
			}
		},
		data() {
			return {
				modalSrc:'',
				previewVisible: false
			}
		},
		methods: {
			getContainer() {
				return document.body;
			},
			preview() {
				// 保留完整地址（含签名参数），避免 OSS/CDN 鉴权失效
				this.modalSrc = this.src;
				this.previewVisible = true;
			},
			cancel() {
				this.previewVisible = false;
			}
		}
	}
</script>

<style lang="less" scoped>
	
	.x-image img {
		border-radius: 5px;
		object-fit: cover;
	}
	
	.x-image {
		cursor: pointer;

		a {
			display: block;
			font-size: 12px;
		}
	}
</style>